import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Loader from 'react-loader-spinner'
import {
 selectLoginData,
 updateUserName,
 updatePassword,
 loginAsyncDocPanel,  
} from './loginSlice';
import styles from './login.module.css';

export function Login() {
  let {UserName, Processing, Password,LoginMessage }  = useSelector(selectLoginData);
  const dispatch = useDispatch();
  return (
    <div>
      <div className={styles.row}>
        <label  
          htmlFor="userNameInput">Username
        </label>
        <input
          id="userNameInput"
          className={styles.input}
          aria-label="UserName"
          value={UserName}
          onChange={e => dispatch(updateUserName(e.target.value))}
        >
        </input>
        </div>
        <div className={styles.row}>
        <label  
          htmlFor="userPasswordInput">
            Password
        </label>
        <input
          id="userPasswordInput"
          className={styles.input}
          aria-label="Password"
          type="password"
          value={Password}
          onChange={e => dispatch(updatePassword(e.target.value))}
        >
        </input>
      </div>
      <div className={styles.row}>
        <button
          className={styles.loginBtn}
          aria-label="LoginBtn"
          onClick={() => dispatch(loginAsyncDocPanel(UserName,Password))}
        >
       Login
        </button>
      </div>
      <div className={styles.rowWhite}>
      {(Processing) ? <Loader
         type="Puff"
         color="#00BFFF"
         height={100}
         width={100}
         timeout={3000} //3 secs
 
      /> : ''
      }
         {
           (LoginMessage === '') ? '' : LoginMessage
      }
       </div>
     </div>
  );
}
